import { constant, contains, result } from 'underscore';

const allExtensions = [
  'action',
  'app',
  'call',
  'callout',
  'image',
  'location',
  'price',
  'review',
  'sitelink',
  'structuredsnippet',
  'promotion',
  'filterlink',
  'flyer',
  'video',
  'leadform',
  'logo',
];

const pmaxSupportedExtentions = [
  'action',
  'app',
  'call',
  'callout',
  'image',
  'location',
  'price',
  'review',
  'sitelink',
  'structuredsnippet',
  'promotion',
  'filterlink',
  'flyer',
  'video',
  'leadform',
  'logo',
];

const appSupportedExtensions = [
  'action',
  'call',
  'callout',
  'image',
  'location',
  'price',
  'review',
  'sitelink',
  'structuredsnippet',
  'promotion',
  'filterlink',
  'flyer',
  'video',
  'leadform',
  'logo',
  'businessinfo',
];

const hotelSupportedExtentions = [
  'callout',
];

const campaignType2SupportedExtensions = {
  PerformanceMax: pmaxSupportedExtentions,
  Hotel: hotelSupportedExtentions,
  App: appSupportedExtensions,
};

const DomesticSimplifiedChineseSupportedExtentions = [
  'action',
  'filterlink',
  'image',
  'businessinfo',
  'promotion',
  'sitelink',
];

const campaignTypeSupportedExtensions = campaignType => result(campaignType2SupportedExtensions, campaignType);

export const campaignTypeExtensionTypeFilter = (campaignType) => {
  const supportedExtensions = campaignTypeSupportedExtensions(campaignType);
  const filter = supportedExtensions ?
    extensionType => contains(supportedExtensions, extensionType.toLowerCase()) :
    constant(true);
  return filter;
};

export const extensionCampaignTypeCheck = {
  allExtensions,
  pmaxSupportedExtentions,
  hotelSupportedExtentions,
  appSupportedExtensions,
  DomesticSimplifiedChineseSupportedExtentions,
};
